<template>
  <card-item card="item_user" :tabs="tabs" :activeTab="activeTab" :id="id">
  
  </card-item>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
export default {
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
  },
  async created(){
    this.item = await this.cardContent("users", this.id);
    this.tabs = [
      {
        title: "Информация",
        component: () => import("./Info"),
      },
      {
        title: "Установить пароль",
        component: () => import("./Password"),
      },
    ]
    if(this.item.role.id == 5){
      this.tabs.push({
        title: "Статистика по ТТ",
        component: () => import("./Stats"),
      })
      this.tabs.push({
        title: "Отчет по качественной дистрибьюции",
        component: () => import("./ExportByDate"),
      })
    }
  },
  props: ["id"],
  data() {
    return {
      item: null,
      tabs: [],
      activeTab: 0,
    };
  },
};
</script>